import { TextareaAutosize, TextareaAutosizeProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightLight,
  lineHeight: theme.typography.body1.lineHeight,
  padding: '10px 12px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette?.text?.primary || '#111',
  backgroundColor: theme.palette?.background?.paper || '#fff',
  transition: 'border-color 0.2s, box-shadow 0.2s',

  '&:focus': {
    borderColor: theme.palette?.primary?.main || '#1976d2',
    boxShadow: `0 0 0 2px ${theme.palette?.primary?.main}33`,
    outline: 'none',
  },

  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
}));

export interface CustomTextAreaProps extends TextareaAutosizeProps {
  error?: boolean;
}

export const TextArea: React.FC<CustomTextAreaProps> = ({
  error,
  ...props
}) => {
  return (
    <StyledTextarea
      {...props}
      style={{
        borderColor: error ? '#d32f2f' : undefined,
        ...(props.style || {}),
      }}
    />
  );
};
